import React__default from 'react';
import PropTypes from 'prop-types';
import { FourZeroOneSvg } from '../assets/FourZeroOneSvg.js';
import { ErrorPage } from '../shared/ErrorPage/ErrorPage.js';

const UnauthorizedPage = _ref => {
  let {
    content,
    heading
  } = _ref;
  return /*#__PURE__*/React__default.createElement(ErrorPage, {
    content: content,
    heading: heading,
    image: /*#__PURE__*/React__default.createElement(FourZeroOneSvg, null)
  });
};
UnauthorizedPage.displayName = 'UnauthorizedPage';
UnauthorizedPage.propTypes = {
  content: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired
};

export { UnauthorizedPage };
